import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { reportsApi } from '@/api/index';
import type { ReportRequestFilters } from '@/api/routes/reports/types';

export const fetchReports = createAsyncThunk(
  'reports',
  async (filters: ReportRequestFilters, thunkAPI) => {
    try {
      const response = await reportsApi.getReportList(filters);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
